import { render } from "./TasksTab.vue?vue&type=template&id=41c90a0b&scoped=true"
import script from "./TasksTab.vue?vue&type=script&lang=js"
export * from "./TasksTab.vue?vue&type=script&lang=js"

import "./TasksTab.vue?vue&type=style&index=0&id=41c90a0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c90a0b"]])

export default __exports__